import { useParams } from "react-router-dom";
import Breadcrumb from '../../components/Breadcrumbs/Breadcrumbs';
import CashFlowData from '../../components/Cashflow/InvoiceList';
import { VocuherCategory } from "../../utils/common-utils";

const AccountPayable = () => {
  const params = useParams();
  return (
    <>
      {/* <Breadcrumb /> */}
      <CashFlowData accountType={"Invoices"} type={VocuherCategory.PURCHASE} />
      
    </>
  );
};
export default AccountPayable;